import {Component, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {CrmDataService} from '../../crm-data.service';
import {GalleryImage} from '../../models/gallery-image';
import {environment} from '../../../../environments/environment';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ImageGalleryItemComponent } from './image-gallery-item/image-gallery-item.component';
import { LoaderComponent } from '../loader/loader.component';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'nbd-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ImageGalleryItemComponent, LoaderComponent, MatDialogActions, MatButton, MatDialogClose, AsyncPipe, TranslatePipe]
})
export class ImageGalleryComponent {
  private crm = inject(CrmDataService);


  images$: Observable<GalleryImage[]>;

  selectedImage?: GalleryImage;
  protected readonly environment = environment;

  constructor() {
    this.images$ = this.crm.getImageGallery();
  }
}
